// Generated by CoffeeScript 1.3.3
(function() {
  var initialEditNoteText, loadThumbnailImage, setFeaturedImage, showLoginForm, showRecoverPasswordForm, tidySelects, tidySlider, tidyThumbnailRows;

  (function() {
    var po, s;
    po = document.createElement("script");
    po.type = "text/javascript";
    po.async = true;
    po.src = "https://apis.google.com/js/plusone.js";
    s = document.getElementsByTagName("script")[0];
    return s.parentNode.insertBefore(po, s);
  })();

  setFeaturedImage = function(newImgThumbLink) {
    var current_height, fic, ficIconZoom, ficImg;
    fic = $(".product #featured-image");
    ficIconZoom = fic.find(".icon-zoom");
    ficImg = fic.find("img");
    current_height = 0;
    $(".product .thumbs a").removeClass("active");
    newImgThumbLink.addClass("active");
    current_height = ficImg.outerHeight();
    fic.css("height", current_height);
    ficIconZoom.hide();
    return ficImg.animate({
      opacity: 0
    }, 300, function() {
      var img;
      img = $(this);
      img.parent("a").attr("href", newImgThumbLink.attr("href"));
      img.parent("a").attr("title", newImgThumbLink.attr("title"));
      img.parent("a").attr("data-image-index", newImgThumbLink.attr("data-image-index"));
      img.attr("src", newImgThumbLink.attr("data-grande-image"));
      img.attr("alt", newImgThumbLink.find("img").attr("alt"));
      return img.one("load", function() {
        var new_height;
        new_height = ficImg.outerHeight();
        return fic.animate({
          height: new_height
        }, 800, "easeInOutQuint", function() {
          return ficImg.animate({
            opacity: 1
          }, 300, function() {
            fic.removeAttr('style');
            return ficIconZoom.css("display", "block").css("opacity", 0).animate({
              opacity: 1
            }, 300, function() {
              return $(this).click(function() {
                return fic.find("a").trigger("click");
              });
            });
          });
        });
      }).each(function() {
        if (this.complete) {
          return $(this).load();
        }
      });
    });
  };

  window.setFeaturedImage = setFeaturedImage;

  loadThumbnailImage = function(thumbnail) {
    var current_height, img;
    current_height = 0;
    img = $(thumbnail).find(".image img");
    img.hide();
    return img.one("load", function() {
      return $(thumbnail).find(".image").animate({
        height: img.outerHeight()
      }, 500, "easeOutQuint", function() {
        img.fadeIn(300);
        return $(this).closest('.image').removeAttr('style');
      });
    }).each(function() {
      if (this.complete) {
        return $(this).load();
      }
    });
  };

  showLoginForm = function() {
    $("#customer-recover-password").hide();
    return $("#customer-login").fadeIn();
  };

  showRecoverPasswordForm = function() {
    $("#customer-login").hide();
    return $("#customer-recover-password").fadeIn();
  };

  tidyThumbnailRows = function() {
    var index, thumbnailRows, thumbnailTop, thumbnails, thumbnailsInLastRow, thumbnailsInRow, _i, _len;
    thumbnails = $('.collection .thumbnails .thumbnail');
    thumbnailRows = [];
    $('.collection .thumbnails .row-fluid .clearfix').remove();
    thumbnails.parent('[class*="span"]').each(function() {
      return thumbnailRows.push($(this).position().top);
    });
    for (index = _i = 0, _len = thumbnailRows.length; _i < _len; index = ++_i) {
      thumbnailTop = thumbnailRows[index];
      if (thumbnailRows[index + 1] !== thumbnailTop) {
        thumbnailsInRow = index + 1;
        break;
      }
    }
    thumbnailsInLastRow = thumbnails.length % thumbnailsInRow;
    if (thumbnailsInLastRow === 0) {
      thumbnailsInLastRow = thumbnailsInRow;
    }
    if (thumbnailsInLastRow === 0 && thumbnailsInRow === 1) {
      thumbnailsInLastRow = 1;
    }
    if (thumbnailsInRow === 2) {
      $('.collection .thumbnails .row-fluid [class*="span"]:nth-child(2n)').after('<div class="clearfix"></div>');
    }
    return thumbnails.removeClass('last-row').slice(-thumbnailsInLastRow).addClass('last-row');
  };

  tidySelects = function() {
    $('.selectboxit').removeClass('btn');
    return $('ul.selectboxit-options').each(function() {
      var newWidth;
      newWidth = $(this).closest('.selectboxit-container').width() + 1;
      return $(this).css('width', newWidth);
    });
  };

  tidySlider = function() {
    return $('.rslides-container').each(function() {
      var adjusted_ratio, ratio;
      ratio = $(this).find('.rslides').first().attr('data-video-ratio');
      adjusted_ratio = $(this).closest('.rslides-wrap').width() / ratio;
      $(this).find('.video').height(adjusted_ratio);
      $(this).find('iframe').height(adjusted_ratio);
      return console.log(adjusted_ratio);
    });
  };

  jQuery(document).ready(function($) {
    var $window, rslider, slideins;
    $window = $(window);
    $("[data-target=_blank]").attr("target", "_blank");
    $("[rel=tooltip]").tooltip();
    $("a.fancybox").fancybox({
      padding: 0,
      titleShow: false,
      overlayColor: "#ffffff",
      overlayOpacity: 0.2
    });
    $("header #toggle-mobile-nav").toggle((function() {
      $("header .nav-mobile-list").slideDown(800, "easeInOutQuint");
      return $(this).find('i').removeClass('icon-plus').addClass('icon-minus').hide().fadeIn();
    }), function() {
      $("header .nav-mobile-list").slideUp(800, "easeInOutQuint");
      return $(this).find('i').removeClass('icon-minus').addClass('icon-plus').hide().fadeIn();
    });
    $(".nav-mobile-select select").change(function() {
      return window.location = $(this).val();
    });
    $("#toggle-mobile-search").toggle((function() {
      return $("#mobile-search").slideDown(800, "easeInOutQuint");
    }), function() {
      return $("#mobile-search").slideUp(800, "easeInOutQuint");
    });
    $('.styledselects select.customselect').not('#product-select, .single-option-selector').selectBoxIt({
      showEffect: "fadeIn",
      showEffectSpeed: 100,
      hideEffect: "fadeOut",
      hideEffectSpeed: 100
    });
    tidyThumbnailRows();
    tidySelects();
    tidySlider();
    $(window).resize(function() {
      tidyThumbnailRows();
      tidySelects();
      return tidySlider();
    });
    rslider = $(".rslides");
    slideins = rslider.responsiveSlides({
      auto: parseInt(rslider.attr("data-autoplay")),
      speed: parseInt(rslider.attr("data-transition-duration")),
      timeout: parseInt(rslider.attr("data-duration")),
      pager: true,
      nav: true,
      random: false,
      pause: true,
      pauseControls: false,
      prevText: "Previous",
      nextText: "Next",
      maxwidth: "",
      controls: "",
      namespace: "empyre-default"
    });
    $('.rslides-container').hover((function() {
      return $(this).addClass("hover");
    }), function() {
      return $(this).removeClass("hover");
    });
    $(".thumbnails .thumbnail").each(function() {
      return loadThumbnailImage(this);
    });
    $(".thumbnails .thumbnail").hover((function() {
      return $(this).addClass("hover");
    }), function() {
      return $(this).removeClass("hover");
    });
    return $(".single-option-selector").addClass('span12');
  });

  if ($(".product #featured-image").length) {
    $(".product #featured-image img").css("opacity", 0);
    setFeaturedImage($(".product #featured-image a").first());
  }

  $(".product #featured-image a").click(function(e) {
    $("a.fancybox").eq($(this).attr("data-image-index") - 1).trigger("click");
    return e.preventDefault();
  });

  $(".product .thumbs a").first().addClass("active");

  $(".product .thumbs a").hover(function() {
    return $(this).toggleClass('hover');
  }).click(function(e) {
    if (!$(this).hasClass("active") && $(this).hasClass("hover")) {
      setFeaturedImage($(this));
    }
    return e.preventDefault();
  });

  $(".twitter-feed").tweet({
    avatar_size: 30,
    count: $(".twitter-feed").attr("data-limit"),
    username: $(".twitter-feed").attr("data-source"),
    favorites: false,
    template: "{text} <small>{time}</small>",
    loading_text: "loading tweets..."
  });

  $(".twitter-feed ul li").live("mouseover", function() {
    return $(this).addClass("hover");
  });

  $(".twitter-feed ul li").live("mouseout", function() {
    return $(this).removeClass("hover");
  });

  $(".twitter-feed ul li").live("click", function() {});

  $(".twitter-feed ul li .tweet_time a").live("click", function() {
    return e.preventDefault();
  });

  $(".widget-social-links .social-network a").tooltip();

  $(".cart td.remove a").click(function() {
    if (confirm("Are you sure you want to remove this from your cart?")) {
      remove_item($(this).attr('data-variant-id'));
    }
    return false;
  });

  $(".cart #shipping-calculator a#show-calculator").click(function() {
    $(".cart #shipping-calculator #calculator").fadeIn();
    return $(".cart #shipping-calculator a#show-calculator").hide();
  });

  $(".cart #shipping-calculator a#hide-calculator").click(function() {
    $(".cart #shipping-calculator #calculator").hide();
    return $(".cart #shipping-calculator a#show-calculator").fadeIn();
  });

  initialEditNoteText = $(".cart #order-notes a#edit-note}").text();

  $(".cart #order-notes a#edit-note}").toggle((function() {
    $('#note-preview').hide();
    $(".cart #order-notes #note").fadeIn();
    $(".cart #order-notes #remove-note").show();
    $(this).text('Save note');
    return false;
  }), function() {
    $(".cart #order-notes #note").hide();
    $(".cart #order-notes #remove-note").hide();
    if ($(this).text() === 'Save note' && $('#note').val().length > 0) {
      $('#note-preview').html($('#note').val().replace(/\n/g, '<br>')).fadeIn();
      $(this).text('Edit note');
    } else {
      $(this).hide().text(initialEditNoteText).fadeIn();
    }
    return false;
  });

  showLoginForm();

  if (window.location.hash === "#recover") {
    showLoginFormPasswordForm();
  }

  $("#customer-account a#reset-password").click(function(e) {
    return showRecoverPasswordForm();
  });

  $("#customer-account a#reset-password-cancel").click(function(e) {
    return showLoginForm();
  });

  $("#customer-account .customer_address form").addClass("form-horizontal");

  $("footer #payment-methods a").tooltip();

}).call(this);
